export function Bullet() {
  return (
    <span className="select-none" aria-hidden>•</span>
  );
}